module.exports = __webpack_public_path__ + "static/img/img-tec-model-00.bd0b22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-tec-model-00.png
// module id = 1bbb
// module chunks = 1